import React from 'react';

import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Desktop/components/AllParamsButton';
import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';

import ElectricEnginesFilter from './components/ElectricEnginesFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import YearFilter from './components/YearFilter';
import MileageFilter from './components/MileageFilter';
import BodyFilter from './components/BodyFilter/BodyFilter';
import GearboxFilter from './components/GearboxFilter';
import PriceFilter from './components/PriceFilter';
import WheelFilter from './components/WheelFilter';
import ColorFilter from './components/ColorFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import BatteryTypeFilter from './components/BatteryTypeFilter';
import SpecialFilter from './components/SpecialFilter';

export function ParamsFilterAll() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <BodyFilter />
        <GearboxFilter />
        <PriceFilter />
      </FiltersWrapper>

      <AllParamsButton />

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <WheelFilter />
          <YearFilter />
          <MileageFilter />
          <ColorFilter />
          <EngineCapacityFilter />
          <BatteryTypeFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
        </FiltersWrapper>
      </MoreParams>

      <SpecialFilter />
    </React.Fragment>
  );
}
